PJQ.views.collapse = {};
PJQ.views.collapse.BaseCollapse = PJQ.views.BaseView.extend({
	defaults: {
		onShown: null
	},
	events: {
		"shown.bs.collapse": "onShown",
		"hidden.bs.collapse": "renderChevrons",
		"show.bs.collapse": "renderChevrons",
		"hide.bs.collapse": "renderChevrons"
	},
	afterRender: function () {
		this.$el.collapse();
		this.renderChevrons();
	},
	onShown: function (e) {
		if (typeof this.options.onShown === 'function') {
			let id = e ? $(e.target).attr('id') : null;
			this.options.onShown(id);
		}
		this.renderChevrons();
	},
	renderChevrons: function () {
		this.$('.card-header[data-target]').each(function () {
			let chevron,
				header = $(this),
				target = header.data('target'),
				collapseContainer = $(target);
			header.css('position', 'relative');
			if (_.size(header.find('.chevron')) === 0) {
				chevron = $('<span />', {
					class: 'chevron fal fa-chevron-down position-absolute right-10p top-35 fs-20 text-dark'
				});
				header.append(chevron);
			}
			else {
				chevron = header.find('.chevron');
			}
			chevron.removeClass(collapseContainer.hasClass('show') ? 'fa-chevron-down' : 'fa-chevron-up');
			chevron.addClass(collapseContainer.hasClass('show') ? 'fa-chevron-up' : 'fa-chevron-down');
		});
	}
});
